<template>
  <page-outline :title="$t('Webheader.usercompany')">
    <template slot="pageContent">
      <b-container fluid class="d-flex flex-column">
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="2" class="mb-5 pl-0">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="2" class="mb-5">
            <b-button class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="3" xl="2" class="mb-5">
            <b-button
              @click="exportUserCompany()">
              <i class="fa-light fa-upload"></i>
              <span class="fab-label">{{ $t('common.extract') }}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="3" class="mb-5">
            <b-button variant="primary"
              @click="addUser"
              :disabled="!canAddUser">
              <i class="fa-light fa-plus"></i>
              <span>{{ $t('administration.user_add') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start" v-if="displayFilter">
          <!--Filtre login -->
          <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5 pl-0">
            <span class="filter-item-title">{{ $t('administration.identifier') }}</span>
            <span class="filter-item-content">
              <input v-model="login"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': login}"
                :placeholder="$t('administration.identifier')">
              </input>
            </span>
          </b-col>
          <!-- Filtre nameCompany -->
          <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
            <span class="filter-item-title" for="name-company">{{ $t('administration.company_name') }}</span>
            <select id="select-name-company" class="filter-item-content min-w-100" v-model="nameCompany"
              style="max-width:100%;padding:0.5rem;">
              <option value="" disabled selected>{{ $t('administration.select_company') }}</option>
              <option v-for="(company, index) in allCompanies"
                      :key="'filtered-profile-' + company.name + '-' + index"
                      :value="company.name">
                {{ company.name }}
              </option>
            </select>
          </b-col>
          <!-- Filtre userActive -->
          <b-col sm="6" lg="3" cols="8" class="filter-item-action mb-5">
            <span class="filter-item-title" for="user-active">{{ $t('administration.active') }}</span>
            <select id="select-user-active" ref="selectDoctype" class="filter-item-content min-w-100" v-model="userActive"
              style="max-width:100%;padding:0.5rem;">
              <option value="">{{ $t('administration.select_activity') }}</option>
              <option value="0">{{ $t('administration.no') }}</option>
              <option value="1">{{ $t('administration.in_prgrss') }}</option>
              <option value="2">{{ $t('administration.yes') }}</option>
            </select>
          </b-col>
          <!-- Bouton Effacer et Appliquer -->
          <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-4 pr-0 pb-5">
            <b-button size="sm"
              @click="applyFilter()">
              {{ $t('common.srch') }}
            </b-button>
            <b-button class="mr-3" size="sm"
              @click="clearFilterFields"
              :disabled="!hasInputFilter">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="p-0">
            <spinner v-if="activateSpinner"></spinner>
            <b-table responsive hover v-else-if="UsersList.length > 0"
                     class="table table-striped"
                     :fields="fields"
                     :items="UsersList"
                     :selectable="UsersList.length > 0"
                     :empty-text="$t('common.security.no_result')"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDir"
                     @head-clicked="sortTable"
                     @row-selected="seeUserDetails">
              <template #cell(Active)="data">
                <i v-if="data.value === '0'" class="fa-light fa-xmark btn btn-icon btn-icon-red"></i>
                <i v-if="data.value === '2'" class="fa-light fa-check btn btn-icon btn-icon-green"></i>
                <i v-if="data.value === '1'" class="fa-light fa-warning btn btn-icon btn-icon-orange"></i>
              </template>
              <template #cell(Account)="data">
                {{data.item.Rights[0].AccountName}}
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-4 w-100" @click="activateDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
                <span>{{ data.value.IdUser }}</span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'


export default {
  name: 'Users',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    allCompanies () {
      return this.profiles.map(profile => {
          return {
            name: profile.name
          }
        })
    },
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_delete', true) || this.$engine.rights.rightIs('usercompany_delete_admin', true)
    },
    fields () {
      let fields = [
        { key: 'Name', label: this.$i18n.t('administration.user_name'), class: 'text-center', sortable: true },
        { key: 'Login', label: this.$i18n.t('administration.identifier'), class: 'text-center', sortable: true },
        { key: 'Account', label: this.$i18n.t('administration.company_name'), class: 'text-center', sortable: false },
        { key: 'Active', label: this.$i18n.t('administration.active'), class: 'text-center', sortable: false },
      ]

      if (this.canUserDelete) {
        fields.push({ key: 'delete', label: this.$i18n.t('administration.del'), thClass: 'text-center table-condensed-ipad col-1', tdClass: 'p-0' })
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    loginDirection () {
      return ((this.sortField === 'login' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
        this.nameCompany ||
        this.login ||
        this.userActive) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      canAddUser: false,
      displayFilter: false,
      filterBy: '',
      filterConditions: {},
      hasDefaultFilter: false,
      idUserAcc: '',
      login: '',
      mode: 1,
      nameCompany: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      profiles: [],
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      sortBy: '',
      sortDir: false,
      userActive: '',
      UsersList: []
    }
  },
  created () {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.$bus.$emit('switch-selected-menu', '/usercompany/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Utilisateurs',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
    this.$engine.company.profiles.forEach(profile => {
      let existingProfile = that.profiles.find(obj => obj.idAccount === profile.idAccount)
      if (!existingProfile) {
        that.profiles.push({
          idAccount: profile.idAccount,
          name: profile.nameAccount,
          profiles: [{
            id: profile.id_rights_profile,
            name: profile.libelle
          }]
        })
      } else if (!existingProfile.profiles.some(obj => obj.id === profile.id_rights_profile)) {
        existingProfile.profiles.push({
          id: profile.id_rights_profile,
          name: profile.libelle
        })
      }
    })
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.usercompany.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.usercompany.cleanFilterCondition()
  },
  methods: {
    addUser () {
      let that = this
      loadPage(that, {url: '/addusercompany/undefined'})
    },
    applyFilter (filterConditions = {}) {
      this.filterConditions = filterConditions

      let that = this
      let defaultFilter = this.$engine.usercompany.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter)
      this.$engine.usercompany.cleanFilterCondition()
      this.$engine.usercompany.userActive = this.userActive
      this.$engine.usercompany.nameCompany = this.nameCompany.trim()
      this.$engine.usercompany.login = this.login.trim()

      for (let propertyCustom in filterConditions) {
        this.$engine.usercompany[propertyCustom] = filterConditions[propertyCustom]
      }
      filterConditions = this.$engine.usercompany.getConditionObject()
      // this.$emit('applyFilter', actualFilter.getConditionObject())

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.users.length
        resp.data.users.forEach(item => {
          item.company_name = item.company_name
          item.login = item.login
          item.active = item.active
        })
        requests = resp.data.users
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.nameCompany = ''
      this.login = ''
      this.userActive = ''
      this.communicateChange()
      // this.applyFilter()
    },
    deleteFilter () {
      this.$engine.usercompany.saveDefaultFilter({})
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: this.$i18n.t('administration.del_filter'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getCompanyName (infos) {
      return infos.Rights && infos.Rights[0] && infos.Rights[0].AccountName ? infos.Rights[0].AccountName : ''
    },
    saveDefaultFilter () {
      let that = this

      let defaultFilter = {
        nameCompany: this.nameCompany.trim(),
        login: this.login.trim(),
        userActive: this.userActive
      }

      this.$engine.usercompany.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportUserCompany () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = this.$t('administration.company_name') + ';' +
        this.$t('administration.identifier') + ';' +
        this.$t('administration.active') + '\r\n'
      let lines = ''
      for (var i = 0; i < this.UsersList.length; i++) {
        let result = this.UsersList[i]
        let iconActive
        if (result.Active === "0") {
          iconActive = this.$t('administration.no')
        } else if (result.Active === "1") {
          iconActive = this.$t('administration.in_prgrss')
        } else if (result.Active === "2") {
          iconActive = this.$t('administration.yes')
        }
        lines += result.Rights[0].AccountName + ';' +
                 result.Login + ';' +
                 iconActive + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'usercompany_' + today.unix() + '.csv'
      if (
      this.$f7.device.os === 'android' ||
      this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.usercompany.getDefaultFilter()) {
          filterConditions = this.$engine.usercompany.getDefaultFilter()
        } else {
          filterConditions = this.$engine.usercompany.getConditionObject()
        }
        filterConditions.sortField = 'SF' + this.sortField
        filterConditions.sortDirection = this.sortDirection
        this.$engine.usercompany.getUsers(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.requestsNumber = resp.data.users.length
          resp.data.users.forEach(item => {
            item.login = item.login
            item.company_name = item.company_name
            item.active = item.active
          })
          requests = resp.data.users
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.UsersList.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      if (this.$engine.usercompany.getDefaultFilter()) {
        filterConditions = this.$engine.usercompany.getDefaultFilter()
      } else {
        filterConditions = this.$engine.usercompany.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection

      this.$engine.usercompany.cleanFilterCondition()
      this.$engine.usercompany.userActive = this.userActive
      this.$engine.usercompany.nameCompany = this.nameCompany.trim()
      this.$engine.usercompany.login = this.login.trim()

      for (let propertyCustom in filterConditions) {
        this.$engine.usercompany[propertyCustom] = filterConditions[propertyCustom]
      }
      filterConditions = this.$engine.usercompany.getConditionObject()

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.paginationObject.nbResults = resp.data.users.length
          resp.data.users.forEach(item => {
          //  item.id_user_account = item.id_user_account
          //  item.login = item.login
          //  item.id_account = item.id_account
            item.delete = item.IdUser
          })
          requests = resp.data.users
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        if (!that.canAddUser) {
          that.$engine.rights.getAllProfilesLight()
          .then(resp => {
            that.$engine.company.profiles = resp.profiles.map(profile => {
              return {
                id_rights_profile: profile.idProfile,
                libelle: profile.libelleProfile,
                idAccount: profile.idAccount,
                nameAccount: profile.accountName
              }
            })
          })
          .catch(err => {
            return err
          })
          .finally(() => {
            that.canAddUser = true
            that.activateSpinner = false
          })
        } else {
          that.activateSpinner = false
        }
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (ressource, id) {
      let that = this
      loadPage(that, {url: '/detailusercompany/' + ressource + '/' + id})
    },
    activateEdit (ressource, id) {
      let that = this
      loadPage(that, {url: '/editusercompany/' + ressource + '/' + id})
    },
    activateDelete ($event, idUserToDelete) {
      $event.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(idUserToDelete)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                that.onRefresh(false)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    reOrderBy (column) {
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.usercompany.getDefaultFilter()) {
        filterConditions = this.$engine.usercompany.getDefaultFilter()
      } else {
        filterConditions = this.$engine.usercompany.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.users.length
        resp.data.users.forEach(item => {
          item.login = item.login
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.users
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.UsersList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeUserDetails (items) {
      this.activateDetail(items[0].IdUser, items[0].id_account)
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = ['Name', 'Login']

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
